export const getValueByDevice = (
  device: "mobile" | "desktop",
  width: number[]
) => {
  return device === "mobile" ? width[0] : width[1];
};
